<ion-header *ngIf="headerModel$ | async as headerModel" mode="ios">
  <ion-toolbar mode="ios">
    <ion-buttons *ngIf="headerModel.buttonType === 'back'" slot="start">
      <app-modal-back-button [priority]="9998" (activated)="onBack()"></app-modal-back-button>
    </ion-buttons>
    <ion-buttons *ngIf="headerModel.buttonType === 'close'" slot="end">
      <app-modal-back-button
        iconSrc="/assets/icon/x-icon-dark.svg"
        [priority]="9998"
        (activated)="onDismiss()"></app-modal-back-button>
    </ion-buttons>
    <ion-title></ion-title>
  </ion-toolbar>
</ion-header>
<ion-content *ngIf="contentState$ | async as contentState">
  <ng-container [ngSwitch]="contentState">
    <ng-container *ngSwitchCase="'choices'">
      <ng-container *ngTemplateOutlet="choices"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'issues'">
      <ng-container *ngTemplateOutlet="issues"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'summary'">
      <ng-container *ngTemplateOutlet="summary"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'view-summary'">
      <ng-container *ngTemplateOutlet="viewSummary"></ng-container>
    </ng-container>
  </ng-container>
  <ng-template #issues>
    <div class="title large">TBD</div>
    <div class="item-container" *ngFor="let item of issuesModel$ | async; trackBy: itemTrackByFn">
      <div class="item-header">
        <div class="title medium">{{ item.name }}</div>
        <div>
          <span class="attribute" *ngIf="item.timeLegend">
            <div class="circle"></div>
            {{ item.timeLegend }}
          </span>
          <span class="attribute" *ngIf="item.locationLegend">
            <div class="circle"></div>
            {{ item.locationLegend }}
          </span>
        </div>
        <div class="label-container">
          <span *ngIf="item.choiceType === 'multiple'" class="label">MULTI-SELECT</span>
          <span *ngIf="item.choiceType === 'multiple-single-choice'" class="label">SINGLE-SELECT</span>
          <span *ngIf="item.choiceLimitLegend" class="label">{{ item.choiceLimitLegend }}</span>
        </div>
      </div>
        <div *ngIf="item.description" class="item-description copy large">
          <app-expandable-para [content]="item.description"></app-expandable-para>
        </div>
      <div class="choice-container">
        <div class="choice" *ngFor="let choice of item.choices; trackBy: itemChoiceTrackByFn">
          <ng-template #headerFragment>
            <div *ngIf="choice.headerTimeSlot" class="label black">{{ choice.headerTimeSlot }}</div>
            <div class="title small">{{ choice.headerTitle }}</div>
          </ng-template>
          <ng-template #inventoryFragment>
            <div class="label" [ngClass]="choice.remainingInventory === 0 ? 'red' : ''">
              {{ choice.inventoryLegend }}
            </div>
          </ng-template>
          <ng-template #issueFragment>
            <div class="issue title small">
              <span class="warning">{{ choice.issueLegend }}</span>
              <span class="count" *ngIf="choice.currentCount">{{ choice.currentCount }}</span>
            </div>
          </ng-template>
          <div class="choice-header">
            <div class="left">
              <ng-container *ngTemplateOutlet="headerFragment"></ng-container>
            </div>
            <div class="right">
              <ng-container *ngTemplateOutlet="inventoryFragment"></ng-container>
              <ng-container *ngIf="!choice.footerTitle">
                <ng-container *ngTemplateOutlet="issueFragment"></ng-container>
              </ng-container>
            </div>
          </div>
          @if (choice.description) {
            <div class="choice-description copy medium">
              <app-expandable-para [content]="choice.description"></app-expandable-para>
            </div>
          }
          <div *ngIf="choice.footerTitle" class="choice-footer">
            <div class="title small">{{ choice.footerTitle }}</div>
            <ng-container *ngTemplateOutlet="issueFragment"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #choices>
    <div class="title large">{{ itemChoices.payload.description }}</div>
    <div class="item-container" *ngFor="let item of itemsModel$ | async; trackBy: itemTrackByFn">
      <div class="item-header">
        <div class="title medium">{{ item.name }}</div>
        <div>
          <span class="attribute" *ngIf="item.timeLegend">
            <div class="circle"></div>
            {{ item.timeLegend }}
          </span>
          <span class="attribute" *ngIf="item.locationLegend">
            <div class="circle"></div>
            {{ item.locationLegend }}
          </span>
        </div>
        <div class="label-container">
          <span *ngIf="item.choiceType === 'multiple'" class="label">MULTI-SELECT</span>
          <span *ngIf="item.choiceType === 'multiple-single-choice'" class="label">SINGLE-SELECT</span>
          <span *ngIf="item.itemAvailability" class="label" [ngClass]="item.itemAvailability.exhausted ? 'red' : ''">
            {{ item.itemAvailability.legend }}</span
          >
          <span *ngIf="item.choiceLimitLegend" class="label">{{ item.choiceLimitLegend }}</span>
        </div>
      </div>
      <div class="restriction-container">
      </div>
      @if(item.description) {
        <div class="item-description copy large">
          <app-expandable-para [content]="item.description"></app-expandable-para>
        </div>
      }
      <div class="choice-container">
        <div class="choice" *ngFor="let choice of item.choices; trackBy: itemChoiceTrackByFn">
          <ng-template #headerFragment>
            <div *ngIf="choice.headerTimeSlot" class="label black">{{ choice.headerTimeSlot }}</div>
            <div class="title small">{{ choice.headerTitle }}</div>
          </ng-template>
          <ng-template #inventoryFragment>
            <div class="label" [ngClass]="choice.remainingInventory === 0 ? 'red' : ''">
              {{ choice.inventoryLegend }}
            </div>
          </ng-template>
          <ng-template #actionsFragment>
            <app-slip-item-choice-actions
              class="title small"
              [checkboxMode]="item.checkboxMode"
              [itemCount]="choice.currentCount"
              [addEnabled]="choice.canAdd"
              [choiceLimit]="choice.choiceLimit"
              [sharedAvailability]="choice.sharedAvailability"
              (choiceChanged)="
                onChoiceChanged(item.singleSelectionMode, item.itemId, choice, $event)
              "></app-slip-item-choice-actions>
          </ng-template>
          <div class="choice-header">
            <div class="left">
              <ng-container *ngTemplateOutlet="headerFragment"></ng-container>
            </div>
            <div class="right">
              <ng-container *ngTemplateOutlet="inventoryFragment"></ng-container>
              <ng-container *ngIf="!choice.footerTitle">
                <ng-container *ngTemplateOutlet="actionsFragment"></ng-container>
              </ng-container>
            </div>
          </div>
          @if (choice.description) {
            <div class="choice-description copy medium">
              <app-expandable-para [content]="choice.description"></app-expandable-para>
            </div>
          }
          <div *ngIf="choice.footerTitle" class="choice-footer">
            <div class="title small">{{ choice.footerTitle }}</div>
            <ng-container *ngTemplateOutlet="actionsFragment"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #summary>
    <div class="summary-container">
      <ng-container *ngIf="summaryModel$ | async as summaryModel">
        <div class="summary-title title medium">Review and {{ summaryModel.requiresPayment ? 'Pay' : 'Submit' }}</div>
        <!-- <p>{{ summaryModel | json }}</p> -->
        <div class="summary-item-container" *ngFor="let item of summaryModel.itemData; trackBy: itemTrackByFn">
          <div class="summary-item">
            <div class="summary-item-heading title small">
              <span>{{ item.name }}</span>
              <span>{{ item.itemTotalLegend }}</span>
            </div>
            <div class="summary-line-item copy medium" *ngFor="let lineItem of item.lineItems">
              <span *ngIf="lineItem.quantityLabel" class="quantity-label">{{ lineItem.quantityLabel }}</span>
              <span *ngIf="lineItem.timeLegend">{{ lineItem.timeLegend }}</span>
              <span *ngIf="lineItem.nameLegend"> {{ lineItem.nameLegend }}</span>
              <span *ngIf="lineItem.costLegend"> - £{{ lineItem.costLegend }}</span>
            </div>
          </div>
        </div>
        <ion-button *ngIf="!summaryModel.requiresPayment" mode="md" color="secondary" (click)="onConfirm()">
          Confirm
        </ion-button>
        <app-student-slip-item-choices-payment
          *ngIf="summaryModel.requiresPayment"
          [slipComponentInfo]="slipComponentInfo"
          [itemChoicesComponentInfo]="summaryModel.itemChoicesComponentInfo"
          [paymentProgress]="summaryModel.paymentProgress"
          [reservationExpiresOn]="summaryModel.reservationExpiresOn"
          (paymentMethodUpdated)="onPaymentMethodUpdated($event)"
          (paymentStatusChange)="onPaymentStatusChange($event)"
          (requestReservationRefresh)="onRequestReservationRefresh()"></app-student-slip-item-choices-payment>
      </ng-container>
    </div>
  </ng-template>
  <ng-template #viewSummary>
    <div class="summary-container">
      <ng-container *ngIf="summaryModel$ | async as summaryModel">
        <div class="summary-title title medium">Order Summary</div>
        <!-- <p>{{ summaryModel | json }}</p> -->
        <div class="summary-item-container" *ngFor="let item of summaryModel.itemData; trackBy: itemTrackByFn">
          <div class="summary-item">
            <div class="summary-item-heading title small">
              <span>{{ item.name }}</span>
              <span>{{ item.itemTotalLegend }}</span>
            </div>
            <div class="summary-line-item copy medium" *ngFor="let lineItem of item.lineItems">
              <span *ngIf="lineItem.quantityLabel" class="quantity-label">{{ lineItem.quantityLabel }}</span>
              <span *ngIf="lineItem.timeLegend">{{ lineItem.timeLegend }}</span>
              <span *ngIf="lineItem.nameLegend"> {{ lineItem.nameLegend }}</span>
              <span *ngIf="lineItem.costLegend"> - £{{ lineItem.costLegend }}</span>
            </div>
          </div>
        </div>
        <ion-button *ngIf="!summaryModel.requiresPayment" mode="md" color="secondary" (click)="onConfirm()">
          Confirm
        </ion-button>
        <app-student-slip-item-choices-payment
          *ngIf="summaryModel.requiresPayment"
          [slipComponentInfo]="slipComponentInfo"
          [itemChoicesComponentInfo]="summaryModel.itemChoicesComponentInfo"
          [paymentProgress]="summaryModel.paymentProgress"
          [reservationExpiresOn]="summaryModel.reservationExpiresOn"
          (paymentMethodUpdated)="onPaymentMethodUpdated($event)"
          (paymentStatusChange)="onPaymentStatusChange($event)"
          (requestReservationRefresh)="onRequestReservationRefresh()"></app-student-slip-item-choices-payment>
      </ng-container>
    </div>
  </ng-template>
</ion-content>
<ion-footer mode="ios" #footer topBorder *ngIf="footerModel$ | async as footerModel">
  <ion-toolbar>
    <div slot="end" class="title small">{{ footerModel.summary }}</div>
    <ion-button mode="md" slot="end" [disabled]="!footerModel.canProceed" class="ph-btn-white" (click)="onNext()">
      NEXT
    </ion-button>
  </ion-toolbar>
</ion-footer>
